import { useEffect } from 'react';
import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals';

const PerformanceMonitor = () => {
  useEffect(() => {
    // Only log Core Web Vitals in development
    if (process.env.NODE_ENV === 'development') {
      getCLS((metric) => console.log('CLS:', metric));
      getFID((metric) => console.log('FID:', metric));
      getFCP((metric) => console.log('FCP:', metric));
      getLCP((metric) => console.log('LCP:', metric));
      getTTFB((metric) => console.log('TTFB:', metric));
    }

    // Monitor performance metrics
    if ('performance' in window) {
      // Monitor page load time
      window.addEventListener('load', () => {
        try {
          const navigation = performance.getEntriesByType('navigation')[0];
          if (navigation && process.env.NODE_ENV === 'development') {
            console.log('Page Load Time:', navigation.loadEventEnd - navigation.loadEventStart);
            console.log('DOM Content Loaded:', navigation.domContentLoadedEventEnd - navigation.domContentLoadedEventStart);
          }
        } catch (error) {
          console.warn('Performance monitoring error:', error);
        }
      });

      // Monitor resource loading - only log slow resources or errors
      const observer = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          if (entry.entryType === 'resource') {
            // Only log resources that took longer than 1000ms, failed, or are large images
            if (entry.duration > 1000 || entry.transferSize === 0 || 
                ((entry.name.includes('.jpg') || entry.name.includes('.png')) && entry.transferSize > 500000)) {
              console.log(`Slow/Large resource: ${entry.name} in ${entry.duration}ms (${Math.round(entry.transferSize / 1024)}KB)`);
            }
          }
        });
      });
      
      try {
        observer.observe({ entryTypes: ['resource'] });
      } catch (error) {
        console.warn('Performance observer error:', error);
      }
      
      return () => {
        try {
          observer.disconnect();
        } catch (error) {
          console.warn('Performance observer disconnect error:', error);
        }
      };
    }
  }, []);

  return null;
};

export default PerformanceMonitor;
